import { render, staticRenderFns } from "./TendencyList.vue?vue&type=template&id=055e2d13&scoped=true"
import script from "./TendencyList.vue?vue&type=script&lang=js"
export * from "./TendencyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055e2d13",
  null
  
)

export default component.exports